import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/loading.json";

export default function LoadingSegment({text}){
    return(
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                padding: '24px',
            }}
        >
            {text && <Typography variant="body1" sx={{marginBottom: '16px', textAlign: 'center'}}>
                {text}
            </Typography>}
            <Box sx={{width: 120, height: 120}}>
                <Lottie
                    animationData={loadingAnimation}
                    loop
                    autoplay
                    style={{width: '100%', height: '100%'}}
                />
            </Box>
        </Box>
    )
}
